// SeoLinkTagsHelmet.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { UTM_WHITE_LIST } from '../resource/fetchOptionHeader';

export const SeoLinkTagsHelmet = ({
  url,
  availableLanguages,
  currentLanguage,
}) => {
  const location = useLocation();
  if (!url) return null;

  const minimalUrl = new URL(`${url}${location?.search}`);
  const minimalUrlSearchParams = minimalUrl.searchParams;
  [...minimalUrlSearchParams.keys()].forEach(key => {
    if (!UTM_WHITE_LIST.includes(key)) {
      minimalUrlSearchParams.delete(key);
    }
  });
  const urlWithUserLang = new URL(minimalUrl.href);
  urlWithUserLang.searchParams.set('lang', currentLanguage);

  const urlWithLangEn = new URL(minimalUrl.href);
  urlWithLangEn.searchParams.set('lang', 'en');

  return (
    <Helmet>
      <link rel="canonical" href={urlWithUserLang.href} />
      <link rel="alternate" hrefLang="x-default" href={urlWithLangEn.href} />
      {availableLanguages.map(lang => {
        const url = new URL(minimalUrl.href);
        if (lang.toLowerCase() === 'zh-hant') {
          url.searchParams.set('lang', 'zh-TW');
          return (
            <>
              <link
                key={lang}
                rel="alternate"
                hrefLang={lang}
                href={url.href}
              />
              <link
                key="'zh-TW'"
                rel="alternate"
                hrefLang="'zh-TW'"
                href={url.href}
              />
            </>
          );
        } else {
          url.searchParams.set('lang', lang);
          return (
            <link key={lang} rel="alternate" hrefLang={lang} href={url.href} />
          );
        }
      })}
    </Helmet>
  );
};

SeoLinkTagsHelmet.propTypes = {
  url: PropTypes.string,
  currentLanguage: PropTypes.string,
  availableLanguages: PropTypes.array,
};

SeoLinkTagsHelmet.defaultProps = {
  url: '',
  availableLanguages: [],
  currentLanguage: '',
};

export default SeoLinkTagsHelmet;
